import React, { Component } from 'react';
import ScriptTag from 'react-script-tag';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Can from '../../common/guards/can';
import RedirectToLogin from '../../common/redirect-to-login';
import Footer from '../../footer/user-footer';
import MainPopups from './main-popups';
import { footerLinksForUserLayout, footerLinksForPreloginUserLayout } from '../../../data/footerLinks';
import { check as loggedIn, isRepLoggedIn } from '../../../utils/tokenUtils';
import { tradeSiteEnabled } from '../../../utils/toggles';
import UserNavigation from '../user-navigation/user-navigation';
import { USER_TYPE_PRE_LOGIN, USER_TYPE_RETAILER } from '../../../data/userTypes';
import { getPpcManagementUrl } from '../../../actions/ppc';

import '../../sidenav/sidenav.css';
import './main-layout.css';
import CookieConsent from '../../cookie-consent/cookie-consent';

class PseudoLoginIndicator extends Component {
  componentDidMount() {
    const { user } = this.props;
    const mode = user.attributes['pseudo-login'] ? 'demo_mode' : 'standard_mode';

    TagManager.dataLayer({
      dataLayer: {
        viewMode: mode
      }
    });
  }

  render() {
    if (!this.props.active) return null;

    return (
      <div className="pseudo-login-indicator">
        Pseudo login active
      </div>
    );
  }
}

class MainLayout extends Component {
  componentDidMount() {
    this.props.dispatch(getPpcManagementUrl());
  }

  waitForElementToDisplay = (selector, callback, checkFrequencyInMs, timeoutInMs) => {
    const startTimeInMs = Date.now();
    (function loopSearch() {
      if (document.querySelector(selector) != null) {
        callback();
      } else {
        setTimeout(() => {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
            return;
          }
          loopSearch();
        }, checkFrequencyInMs);
      }
    }());
  }

  gold = path => this.props.hasGoldTheme && !path.includes('privacy-policy')
  setScrolling() {
    return this.props.viewConfig.lockSroll ? 'noscroll' : '';
  }

  render() {
    if (this.props.user.attributes['user-group'] === 'savi_auditor') {
      return <Redirect to="/admin"/>;
    }
    if (isRepLoggedIn()) {
      return <Redirect to="/team"/>;
    }

    const {
      component: RenderComponent,
      action,
      subjectClass,
      private: privateRoute,
      showBasketDropdown,
      hidePseudo,
      isPseudoLogin,
      viewConfig,
      hasRewardOutlet,
      hasGoldTheme,
      user,
      path,
      ...rest
    } = this.props;
    const userFrontendClassName = this.gold(path) ? 'user-frontend-gold' : 'user-frontend';
    let frontendContainerClassName = 'frontend-container';

    if (hasGoldTheme && path === '/') {
      frontendContainerClassName += ' user-frontend-background';
    }

    if (hidePseudo && isPseudoLogin) {
      return <Redirect to='/'/>;
    }

    if (!loggedIn()) {
      if ((tradeSiteEnabled() && path === '/') || !privateRoute) {
        return (
          <Route
            {...rest}
            path="/"
            render={matchProps => (
              <div className={userFrontendClassName}>
                <div className={this.setScrolling.bind(this)}>
                  <div className="frontend-container">
                    <CookieConsent/>
                    <RenderComponent {...matchProps} area={USER_TYPE_PRE_LOGIN}/>
                    <Footer links={footerLinksForPreloginUserLayout}/>
                  </div>
                </div>
              </div>
            )}
          />
        );
      }

      return (
        <Route
          {...rest}
          render={() => <RedirectToLogin requestedPath={window.location.pathname}/>}
        />
      );
    }
    return (
      <Route
        {...rest}
        render={matchProps => (
          <div className={userFrontendClassName}>
            <ScriptTag type="text/javascript" src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"/>
            <ScriptTag>{
              this.waitForElementToDisplay('.goog-te-gadget', () => {
                const googTeGadget = document.getElementsByClassName('goog-te-gadget')[0];
                const poweredByText = googTeGadget.getElementsByTagName('div')[0].nextSibling;
                const span = googTeGadget.getElementsByTagName('span')[0];

                if (typeof poweredByText.data === 'string') {
                  span.prepend(poweredByText);
                }
              }, 125, 9000)
            }
            </ScriptTag>
            <Can action={action} cannot={<Redirect to="/my-profile"/>} subjectClass={subjectClass}>
              <div className={this.setScrolling.bind(this)}>
                <div className={frontendContainerClassName}>
                  <PseudoLoginIndicator active={isPseudoLogin} user={user}/>
                  <UserNavigation gold={ this.gold(path) }/>
                  <RenderComponent {...matchProps} area={USER_TYPE_RETAILER}/>
                  <Footer links={footerLinksForUserLayout}/>
                </div>
              </div>
            </Can>
            <MainPopups/>
          </div>
          )}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.viewConfig.profile,
  viewConfig: state.viewConfig,
  isPseudoLogin: state.viewConfig.profile.attributes['pseudo-login'],
  hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet'],
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching,
  showBasketDropdown: state.viewConfig.showBasketDropdown,
  hasGoldTheme: state.deep.my_profile.has_ignite_gold_outlet
});

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/components/layout/main/index.jsx